import { IFAQItem } from "@/v2/types/faq";

export type ChatMessage = {
  role: "system" | "user" | "assistant";
  content: string;
};

export type File = {
  label: string;
  type: "image" | "pdf" | "video";
  url: string;
};

export type RelatedURL = {
  label: string;
  url: string;
};

export type TVoiceMode = {
  isVoiceModeStart: boolean;
  isVoiceModeEnd: boolean;
  isVoiceModeMiddle: boolean;
};

export type Conversation = {
  id: number;
  state: string;
  chatLog: ChatMessage;
  files: File[] | null;
  relatedURL: RelatedURL | null;
  forms?: boolean;
  voiceMode?: TVoiceMode;
};

export type ChatResponse = {
  chat_id: string | null;
  files_dict: File[] | null;
  main_response: string;
  quick_reply_messages: string[];
  state: string;
  forms?: boolean;
  voice_data?: string | null;
  related_url: RelatedURL | null;
  faqs?: IFAQItem[];
};

export type ChatRequest = {
  code: string;
  uid: string;
  utterance: string;
};

export type ChatOptionButton = {
  label: string;
  value: string;
};

export interface IFormBase {
  chat_settings_id: string;
  created_at: string;
  description?: string;
  id: string;
  title: string;
}

export interface FormGeneral extends IFormBase {
  forms: IForm[];
}

export interface IForm extends IFormBase {
  num_id: number;
  options: string[];
  required: boolean;
  type:
    | "text"
    | "email"
    | "textarea"
    | "pulldown"
    | "radio"
    | "checkbox"
    | "date"
    | "phone"
    | "privacypolicy";
  url?: string;
  form_id: string;
}

export type RagResponse = {
  chat_id: string;
  files_dict: File[];
  quick_reply_messages: string[];
  forms_generals: FormGeneral[];
  forms?: boolean;
  state: string;
  voice_data?: string;
  related_url: RelatedURL | null;
  faqs?: IFAQItem[];
};

export type CreateSessionChatRequest = {
  platform: string;
  agent_id: string;
  source: string | null;
};

export type CreateSessionChatResponse = {
  chat_session_id: string;
};

export type StartWebChatResponse = {
  chat_id: string;
};

export type PostFormDataResponse = {
  success: boolean;
};

// Request types
export type AgentRequest = {
  agent_id: string;
};

export type StartWebChatRequest = {
  chat_session_id: string;
};

export type PostChatMessageRequest = {
  knowledge_data_store_id: string;
  chat_settings_id: string;
  message_list: ChatMessage[];
  voice_id: string;
  chat_session_id: string;
};

export type GetRAGInfoRequest = {
  knowledge_data_store_id: string;
  chat_settings_id: string;
  message_list: ChatMessage[];
  chat_id: string;
};

export type PostFormDataRequest = {
  form_id: string;
  form_log: Record<string, string | boolean | string[]>;
};

export interface ColorOption {
  value: string;
  label: string;
  color?: string;
}

export const colorOptions: ColorOption[] = [
  { value: "default", label: "LINEグリーン（デフォルト）", color: "#06C755" },
  { value: "red_rose", label: "レッド", color: "#FF5230" },
  { value: "pink_blossom", label: "ピンク", color: "#FF85D4" },
  { value: "forest_green", label: "グリーン", color: "#1AB525" },
  { value: "mountain_green", label: "エメラルド", color: "#00B0A8" },
  { value: "brown", label: "ブラウン", color: "#B58F60" },
  { value: "custom", label: "色指定", color: "" },
];

export const defaultColorOption: ColorOption = {
  value: "default",
  label: "LINEグリーン（デフォルト）",
  color: "#06C755",
};

export enum DesignOption {
  ICON = "icon", // アイコンボタン（テーマカラー）
  ICON_LIGHT = "icon_light", // アイコンボタン（ホワイト）
  ICON_DARK = "icon_dark", // アイコンボタン（ブラック）

  BUTTON_THEME = "button_theme", // ボタン（テーマカラー）
  BUTTON_LIGHT = "button_light", // ボタン（ホワイト）
  BUTTON_DARK = "button_dark", // ボタン（ブラック）

  AVATAR = "avatar", // アバター
  CHARACTER_BAR = "character_bar", // キャラ付き相談バー
  BANNER = "banner", // バナー
}

export enum DisplayPositionOption {
  RIGHT = "right",
  LEFT = "left",
}

export enum DisplayMode {
  CHARACTER = "character",
  CHAT = "chat",
}

export enum HeaderDisplayOption {
  ICON_AND_NAME = "icon_and_name",
  IMAGE = "image",
}

export enum DesktopViewOption {
  FULL_SCREEN = "full_screen",
  SMALL_SCREEN = "small_screen",
}

export enum IframeState {
  OPEN = "open",
  CLOSE = "close",
}
